export const graphqlBaseUrl = process.env.REACT_APP_GRAPHQL_BASE_URL || "https://api-dev.travelnet.in/graphql/admin";
export const hotelDashboardUrl = process.env.REACT_APP_HOTEL_DASHBOARD_URL;
